import { TENANT_COLORS } from 'javascripts/constants';

export default () => {
  const rootElement = document.documentElement;
  let tenant = 'lp';

  for (let i = 0; i < rootElement.classList.length; i += 1) {
    const className = rootElement.classList.item(i);

    if (className.indexOf('v-') !== -1) {
      tenant = className.substring(2);
    }
  }

  return TENANT_COLORS[tenant];
};
